export default [
    {
        name: 'order',
        path: '/order',
        component: () => import(/* webpackChunkName: "order" */ '@/view/orders/OrderList.vue'),
        meta: {
            action: 'index',
            resource: 'order',
        },
    },
    {
        name: 'orderEdit',
        path: 'order/:id',
        component: () => import(/* webpackChunkName: "orderEdit" */ '@/view/orders/OrderEdit.vue'),
        meta: {
            action: 'view',
            resource: 'order',
        },
    },
    {
        path: '/order/flow',
        name: 'orderFlow',
        component: () => import(/* webpackChunkName: "orderFlow" */ '@/view/orders/OrderFlow.vue'),
        meta: {
            action: 'create',
            resource: 'order',
        },
    },
    {
        path: '/order/energy/create',
        name: 'orderCreateEnergy',
        component: () => import(/* webpackChunkName: "orderCreateEnergy" */ '@/view/orders/OrderCreateEnergy.vue'),
        meta: {
            action: 'create',
            resource: 'order',
        },
    },
    {
        path: '/order/battery/create/:productID',
        name: 'orderCreateBattery',
        component: () => import(/* webpackChunkName: "orderCreateBattery" */ '@/view/orders/OrderCreateBattery.vue'),
        meta: {
            action: 'create',
            resource: 'order',
        },
    },
    {
        path: '/order/battery/mkb/create/:productID',
        name: 'orderCreateBatteryMKB',
        component: () => import(/* webpackChunkName: "orderCreateBatteryMKB" */ '@/view/orders/OrderCreateBatteryMKB.vue'),
        meta: {
            action: 'create',
            resource: 'order',
        },
    },
    {
        path: '/order/battery-roi/mkb/create/:productID',
        name: 'orderCreateBatteryRoiMKB',
        component: () => import(/* webpackChunkName: "orderCreateBatteryMKBRoi" */ '@/view/orders/OrderCreateBatteryRoiMKB.vue'),
        meta: {
            action: 'create',
            resource: 'order',
        },
    },
    {
        path: '/order/battery/soho/create/:productID',
        name: 'orderCreateBatterySOHO',
        component: () => import(/* webpackChunkName: "orderCreateBattery" */ '@/view/orders/OrderCreateBatterySOHO.vue'),
        meta: {
            action: 'create',
            resource: 'order',
        },
    },
    {
        path: '/order/battery/sustainability-advanced/create/:productID',
        name: 'orderCreateBatterySustainabilityAdvanced',
        component: () => import(/* webpackChunkName: "orderCreateBatterySustainabilityAdvanced" */ '@/view/orders/OrderCreateSustainabilityAdvanced.vue'),
        meta: {
            action: 'create',
            resource: 'order',
        },
    },
    {
        path: '/order/battery/sustainability-with-product/create/:productID',
        name: 'orderCreateBatterySustainabilityWithProduct',
        component: () => import(/* webpackChunkName: "orderCreateBatterySustainabilityWithProduct" */ '@/view/orders/OrderCreateSustainabilityWithProduct.vue'),
        meta: {
            action: 'create',
            resource: 'order',
        },
    },
    {
        path: '/order/lead/create/:productID',
        name: 'orderCreateLead',
        component: () => import(/* webpackChunkName: "orderCreateEnergy" */ '@/view/orders/OrderCreateLead.vue'),
        meta: {
            action: 'create',
            resource: 'order',
        },
    },
    {
        path: '/order/roi/create/:productID',
        name: 'orderCreateROI',
        component: () => import(/* webpackChunkName: "orderCreateEnergy" */ '@/view/orders/OrderCreateROI.vue'),
        meta: {
            action: 'create',
            resource: 'order',
        },
    },
    {
        path: '/order/letter-of-content/create/:productID',
        name: 'orderCreateLetterOfContent',
        component: () => import(/* webpackChunkName: "orderCreateLetterOfContent" */ '@/view/orders/OrderLetterOfContent.vue'),
        meta: {
            action: 'create',
            resource: 'order',
        },
    },
    {
        path: '/order/sustainability-consultation/create/:productID',
        name: 'orderCreateSustainabilityConsultation',
        component: () => import(/* webpackChunkName: "orderCreateSustainabilityConsultation" */ '@/view/orders/OrderSustainabilityConsultation.vue'),
        meta: {
            action: 'create',
            resource: 'order',
        },
    },
    {
        path: '/order/energy/reoffer',
        name: 'orderReOfferEnergy',
        component: () => import(/* webpackChunkName: "orderReOfferEnergy" */ '@/view/orders/OrderReOfferEnergy.vue'),
        meta: {
            action: 'create',
            resource: 'order',
        },
    },
    {
        path: '/order/svm/create',
        name: 'orderCreateSvm',
        component: () => import(/* webpackChunkName: "orderCreateSvm" */ '@/view/orders/OrderCreateSvm.vue'),
        meta: {
            action: 'create',
            resource: 'order',
        },
    },
    {
        path: '/order/solar-simple/create',
        name: 'orderCreateSolarSimple',
        component: () => import(/* webpackChunkName: "orderCreateSolarSimple" */ '@/view/orders/OrderCreateSolarSimple.vue'),
        meta: {
            action: 'create',
            resource: 'order',
        },
    },
    {
        path: '/order/solar/create',
        name: 'orderCreateSolar',
        component: () => import(/* webpackChunkName: "orderCreateSolar" */ '@/view/orders/OrderCreateSolar.vue'),
        meta: {
            action: 'create',
            resource: 'order',
        },
    },
    {
        path: '/order/shop/create/:productID',
        name: 'OrderCreateShop',
        component: () => import(/* webpackChunkName: "OrderCreateShop" */ '@/view/orders/OrderCreateShop.vue'),
        meta: {
            action: 'create',
            resource: 'order',
        },
    },
    {
        path: '/order/shop/wholesale/create/:productID',
        name: 'OrderCreateShopWholesale',
        component: () => import(/* webpackChunkName: "OrderCreateShop" */ '@/view/orders/OrderCreateShopWholesale.vue'),
        meta: {
            action: 'create',
            resource: 'order',
        },
    },
    {
        path: '/order/hydromx/create',
        name: 'orderCreateHydromx',
        component: () => import(/* webpackChunkName: "orderCreateSvm" */ '@/view/orders/OrderCreateHydromx.vue'),
        meta: {
            action: 'create',
            resource: 'order',
        },
    },
]
